import volume_on from '../../images/png/volume_on.png'
import volume_off from '../../images/png/volume_off.png'
import again from '../../images/png/Pelaa_uudestaan.png'
import help from '../../images/png/Apuva.png'

import { useDispatch, useSelector } from 'react-redux'
import { toggleVolume } from '../../reducers/volumeReducer'

import './PhoneButtons.css'

const PhoneButtons = ({setPage, setShowModal, showModal}) => {
    const volume = useSelector(state => state.volume)
    const dispatch = useDispatch()
    
    return(
        <div className='phonebutton-container'>
            <img src={again} alt='pelaa uudelleen -nappi'
                onClick={() => setPage(true)}/>
            <img src={volume ? volume_on : volume_off} 
                alt='äänet päällä/pois -nappi' 
                onClick={() => dispatch(toggleVolume())}/>
            <img src={help} alt='apua -nappi'
            onClick={() => setShowModal(!showModal)}/>
        </div>
    )
}

export default PhoneButtons